var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search",class:{'is-inline': _vm.isInline}},[_c('input',{staticClass:"search-input",attrs:{"type":"text","placeholder":"Quick search..."},domProps:{"value":_vm.value},on:{"input":_vm.onChange}}),_c('app-icon',{staticClass:"search-icon",attrs:{"icon":"search"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }